import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Empty, message, Button, Card, Alert, Spin } from 'antd';
import moment from 'moment';
import { serverFetch } from '../../server';
import './purchases.css';
import Auth from '../auth/auth';

const Purchases = () => {
    const company = useSelector((s) => s.company);
    const user = useSelector((s) => s.user);

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [client, setClient] = useState();

    const getClient = () =>
        serverFetch('account/Info', { method: 'GET' }, user)
            .then((data) => setClient(data))
            .catch(() => message.error('Ошибка получения информации о клиенте'));

    useEffect(() => {
        user && getData();
        user && getClient();
    }, [user]);

    const getData = () => {
        setLoading(true);

        const queryParams = {
            companyId: company.id,
            useClientId: true,
        };

        serverFetch('sale', { method: 'GET', queryParams: queryParams }, user)
            .then((data) => {
                setItems(data);
                setLoading(false);
            })
            .catch(() => {
                message.error('Ошибка получения покупок');
                setLoading(false);
            });
    };

    const groupedItems = useMemo(() => {
        const groups = new Map();

        (items || []).forEach((item) => {
            const dateKey = moment(item.createdOn).format('YYYY-MM-DD');
            if (!groups.has(dateKey)) {
                groups.set(dateKey, []);
            }
            groups.get(dateKey).push(item);
        });

        return Array.from(groups.entries())
            .sort((a, b) => (a[0] < b[0] ? 1 : -1))
            .map(([dateKey, groupItems]) => ({
                dateKey,
                dateLabel: moment(dateKey).format('DD.MM.YYYY'),
                items: groupItems.sort((a, b) => moment(b.createdOn).valueOf() - moment(a.createdOn).valueOf()),
            }));
    }, [items]);

    const renderCard = (item) => {
        const divRoom = item.roomName ? (
            <>
                <div className='purchase-card-meta'>{item.roomName}</div>
                {item.seansStart ? (
                    <div className='purchase-card-meta'>
                        Визит {moment(item.seansStart).format('DD.MM.YYYY')} {moment(item.seansStart).format('HH:mm')}
                        {item.seansFinish ? ` - ${moment(item.seansFinish).format('HH:mm')}` : ''}
                    </div>
                ) : null}
            </>
        ) : null;

        const divCheck =
            item.fiscalReceiptStatus === 'COMPLETED' && item.fiscalReceiptUrl ? (
                <div className='purchase-card-actions'>
                    <Button href={item.fiscalReceiptUrl} target='_blank'>
                        Показать чек
                    </Button>
                </div>
            ) : null;

        return (
            <Card key={item.id} className='purchase-card' bordered={false}>
                <div className='purchase-card-top'>
                    <a
                        className='purchase-card-id'
                        href={`/sale/${item.clientId}_${item.id}`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Продажа # {item.id}
                    </a>
                    <div className='purchase-card-price'>{item.totalPrice}₽</div>
                </div>
                <div className='purchase-card-name'>{item.productName}</div>
                {item.qtyClients ? <div className='purchase-card-meta'>Клиентов: {item.qtyClients}</div> : null}
                {divRoom}
                {divCheck}
            </Card>
        );
    };

    return (
        <div className='block-content purchases-page'>
            {client && !client.email && (
                <Alert type='warning' message="Укажите адрес почты в профиле пользователя 'Мои данные'" showIcon />
            )}
            {loading ? (
                <div className='purchases-loading'>
                    <Spin />
                </div>
            ) : groupedItems.length === 0 ? (
                <Empty description='Список покупок пуст' />
            ) : (
                <div className='purchases-groups'>
                    {groupedItems.map((group) => (
                        <section key={group.dateKey} className='purchases-group'>
                            <h2 className='purchases-group-date'>{group.dateLabel}</h2>
                            <div className='purchases-cards'>{group.items.map(renderCard)}</div>
                        </section>
                    ))}
                </div>
            )}
            {!user && <Auth />}
        </div>
    );
};

export default Purchases;
